import { render, staticRenderFns } from "./epis.vue?vue&type=template&id=5cb94100&scoped=true"
import script from "./epis.vue?vue&type=script&lang=js"
export * from "./epis.vue?vue&type=script&lang=js"
import style0 from "./epis.vue?vue&type=style&index=0&id=5cb94100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb94100",
  null
  
)

export default component.exports